import Api from './api';

const UserService = {
    cadastro: async (params) => {
        const response = await Api.post('/restrito/usuarios/cadastrar', params, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },

    listar: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/restrito/usuarios/listar',
            params: params,
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },
    deletar: (id) => {
        Api.delete(`/restrito/usuarios/deletar/${id}`, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
    },
    userEdit: async (id) => {
        const response = await Api.get(`/restrito/usuarios/editar/${id}`,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    editar: async (id, params) => {
        const response = await Api.put(`/restrito/usuarios/editar/${id}`,
            params,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    senha: async (id, params) => {
        const response = await Api.put(`/restrito/usuarios/senha/${id}`,
            params,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    }
}

export default UserService;